import { ErrorResponseInterface } from '@systemeio/util'
import { SECURE_AND_PAY_ACCOUNT_API } from 'modules/profile/payment-gateways/integrations/secure-and-pay/api'
import { PaymentSecureAndPayInterface } from 'modules/profile/payment-gateways/integrations/secure-and-pay/types'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export interface UseSecureAndPayRestApiInterface {
  badRequestHandler?: (e: ErrorResponseInterface) => void
}

export const useSecureAndPayRestApi = ({
  badRequestHandler,
}: UseSecureAndPayRestApiInterface = {}) => {
  const { fetcher } = useFetch<RequestMethodsEnum>({
    method: RequestMethodsEnum.post,
    badRequestHandler,
  })

  const { fetcher: deleteFetcher } = useFetch<RequestMethodsEnum>({
    method: RequestMethodsEnum.delete,
    badRequestHandler,
  })

  return {
    connect: (data: PaymentSecureAndPayInterface) =>
      fetcher(`${SECURE_AND_PAY_ACCOUNT_API}/connect`, data),
    disconnect: () => deleteFetcher(`${SECURE_AND_PAY_ACCOUNT_API}/disconnect`),
  }
}
